export const WECHAT_PSP_ID = 'M99BILLW';
export const CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
export const ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
export const EPAYGATE_PSP_ID = 'EPAYGATE';
export const IXOPAY_PSP_ID = 'EIXOPAY';
export const UPLIFT_PSP_ID = 'MUPLIFT';
export const PLEDG_PSP_ID = 'MPLEDG';
export const ONEY_PSP_ID = 'EHIPAYBNPL';
export const HIPAY_PSP_ID = 'MHIPAY';
export const PAYPAL_PSP_ID = 'MHIPAYPP';
export const ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER
export const ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT
export const NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER
export const NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT
export const DEPOSIT_OFFSET_PSP_ID = 'OF';
export const HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
export const EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT
export const OGONE_CMTA_PSP_ID = 'MOGONE';
export const OGONE_PSP_ID = 'EOGONE';
export const PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
export const BANK_TRANSFER_LABEL = 'Bank Transfer';
export const CHEQUE_LABEL = 'Cheque';
export const CREDIT_CARD_LABEL = 'Credit Card';
export const PAYPAL_LABEL = 'Paypal';
export const VOXPAY_PSP_ID_PREFIX = 'EVOXPAY';
export const VOXPAY_PHONE_PSP_ID = 'EVOXPAY_PHONE';
export const VOXPAY_PHONE_LABEL = 'Phone';
export const VOXPAY_EMAIL_PSP_ID = 'EVOXPAY_EMAIL';
export const VOXPAY_EMAIL_LABEL = 'Email';
export const VOXPAY_SMS_PSP_ID = 'EVOXPAY_SMS';
export const VOXPAY_SMS_LABEL = 'Sms';
export const NAPAY_PSP_ID = 'NAPAY';
export const PROVIDER_ID_EVOPAY_PREFIX = 'EVOXPAY';
export const PAYMENT_METHOD_CATEGORY = {
  BUY_NOW_PAY_LATER: 'BuyNowPayLater',
  CREDIT_CARD: 'CreditCard',
  CARD: 'card',
  PAYPAL: 'Paypal',
  CHEQUE: 'Cheque',
  DIRECT_DEBIT: 'DirectDebit',
  BANK_TRANSFER: 'BankTransfer',
};
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const INVALID_PHONE = 'INVALID_PHONE';
